class ViewDetails {
    constructor() {
        this.element = document.getElementById("view-details");
        this.companyDetails = document.getElementById("company-details");
        this.loadedDetails = false;

        if (!this.element || !this.companyDetails) {
            return;
        }
        this.url = this.element.dataset.url;
        this.text = {
            show: this.element.textContent,
            hide: this.element.dataset.text,
        };
        this.partnerId = this.element.dataset.id;
        this.bind();
    }

    toggle() {
        this.toggleText();
        this.toggleDetails();
    }

    toggleText() {
        this.element.textContent = (this.element.textContent === this.text.show)
            ? this.text.hide
            : this.text.show;
    }

    toggleDetails() {
        this.companyDetails.classList.toggle("d-n");
    }

    bind() {
        this.element.addEventListener("click", (event) => {
            event.preventDefault();
            if (this.loadedDetails) {
                this.toggle();

                return;
            }

            fetch(`${this.url}?partnerId=${this.partnerId}&withParent=false`)
                .then(response => response.text())
                .then((data) => {
                    this.companyDetails.innerHTML = data;
                    this.loadedDetails = true;
                    this.toggle();
                });
        });
    }
}

export default ViewDetails;
